import _styled from '@emotion/styled/base';
import * as CoachMarkPrimitive from '@radix-ui/react-popover';
import React__default from 'react';
import { Flex } from '../Flex/index.js';
import { PopoverStyles } from './styles.js';
import { jsx } from '@emotion/react/jsx-runtime';
import { spacing } from '@hubble/tokens/web';

const PopoverRoot = _styled(CoachMarkPrimitive.Root, {
  target: "e1tbqbeo0"
})();
const PopoverPortal = CoachMarkPrimitive.Portal;
const PopoverTrigger = React__default.forwardRef(({
  children,
  ...props
}, ref) => jsx(CoachMarkPrimitive.Trigger, {
  asChild: true,
  ref: ref,
  ...props,
  children: children
}));
const PopoverContent = React__default.forwardRef(({
  align = 'start',
  children,
  height,
  width,
  ...props
}, ref) => jsx(CoachMarkPrimitive.Content, {
  ref: ref,
  align: align,
  asChild: true,
  sideOffset: 4,
  collisionPadding: 16,
  ...props,
  children: jsx(PopoverStyles, {
    height: height,
    width: width,
    children: jsx(Flex, {
      flexDirection: "column",
      gap: spacing[4],
      children: children
    })
  })
}));
const Popover = Object.assign(PopoverRoot, {
  Portal: PopoverPortal,
  Trigger: PopoverTrigger,
  Content: PopoverContent,
  displayName: 'Popover'
});

export { Popover };
